
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the HakkindaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-hakkinda',
  templateUrl: 'hakkinda.html',
})
export class HakkindaPage {
  kayitliresim = "assets/imgs/logo.png"
  constructor(public navCtrl: NavController,

    public navParams: NavParams) {
  }

  ionViewDidLoad() {
   
  }
  // Ara(numara) {
  //   this.callNumber.callNumber(numara, true)
  //     .then(res => console.log('Launched dialer!', res))
  //     .catch(err => console.log('Error launching dialer', err));
  // }

  // Ara2(numara) {
  //   this.callNumber.callNumber(numara, true)
  //     .then(res => console.log('Launched dialer!', res))
  //     .catch(err => console.log('Error launching dialer', err));
  // }


}



// WEBPACK FOOTER //
// ./src/pages/hakkinda/hakkinda.ts